'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _TextField = require('material-ui/TextField');

var _TextField2 = _interopRequireDefault(_TextField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextFieldComponent = function (_Component) {
  _inherits(TextFieldComponent, _Component);

  function TextFieldComponent() {
    _classCallCheck(this, TextFieldComponent);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(TextFieldComponent).apply(this, arguments));
  }

  _createClass(TextFieldComponent, [{
    key: 'handleChange',
    value: function handleChange(e) {
      this.props.update(e.target.value);
    }
  }, {
    key: 'handleBlur',
    value: function handleBlur(e) {
      this.props.blur();
    }
  }, {
    key: 'render',
    value: function render() {
      var errorDiv = this.props.dirty && !this.props.valid ? _react2.default.createElement(
        'div',
        null,
        this.props.error || ''
      ) : null;

      var type = this.props.schema.inputtype || 'text';

      return _react2.default.createElement(_TextField2.default, {
        value: this.props.value || '',
        fullWidth: true,
        disabled: this.props.schema.readonly ? true : false,
        type: type,
        errorText: errorDiv,
        floatingLabelText: this.props.title,
        onChange: this.handleChange.bind(this),
        onBlur: this.handleBlur.bind(this) });
    }
  }]);

  return TextFieldComponent;
}(_react.Component);

exports.default = TextFieldComponent;


/** WEBPACK FOOTER **
 ** ../biro-material-ui/lib/components/TextField.js
 **/